import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import organization from "../models/organization/organizationSlice";
import applicationStatus from "../models/applicationStatusSlice";
import applications from "../models/applications/applicationsSlice";
import asyncRequestStatus from "../models/asyncRequestStatusReducer";
import applicationDetail from "../models/applications/applicationDetailSlice";
import myUser from "../models/users/myUserSlice";
import systemMessage from "../models/systemMessageSlice";

export const store = configureStore({
  reducer: {
    organization,
    applicationStatus,
    applicationDetail,
    asyncRequestStatus,
    myUser,
    applications,
    systemMessage,
  },
});

export function getDispatch() {
  return store.dispatch;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
